import { useMemo } from 'react'
import {
    jornada,
    JornadaDiariaQueryXor,
    JornadaMensalQueryXor,
} from 'service/api'
import { useStore } from 'store'
import { diarioColumns, mensalColumns } from '../columns'
import LocaisToolbar from '../toolbar/locais-toolbar'
import { DigitacaoSubPages } from './DigitacaoSubPages'
import { useDigitacaoContext } from './useDigitacaoContext'

export default function DigitacaoLocaisPage() {
    const { view, queryParams } = useDigitacaoContext()
    const empresa = useStore(state => state.company)

    const {
        data: mensal,
        isLoading: isLoadingMensal,
        error: mensalError,
    } = jornada.mensal.useFetch({
        queryParams: queryParams as JornadaMensalQueryXor,
        enabled:
            !('dia' in queryParams) &&
            'localId' in queryParams &&
            !!queryParams.localId &&
            !!queryParams.funcionarioId,
    })

    const {
        data: diario,
        isLoading: isLoadingDiario,
        error: diarioError,
    } = jornada.diaria.useFetch({
        queryParams: queryParams as JornadaDiariaQueryXor,
        enabled:
            'dia' in queryParams &&
            'localId' in queryParams &&
            !!queryParams.localId &&
            !!queryParams.empresaId,
    })

    const columns = useMemo(() => {
        return view === 'mensal'
            ? mensalColumns(empresa?.exibirSaldoDiario == 'S')
            : diarioColumns
    }, [view, empresa?.exibirSaldoDiario])

    const errorMensal = (() => {
            if (mensalError) return mensalError
            if (!(queryParams as any).localId)
                return { message: 'Local não selecionado' }
            if (!(queryParams as any).funcionarioId)
                return { message: 'Funcionário não selecionado' }
        })(),
        errorDiario = (() => {
            if (diarioError) return diarioError
            if (!(queryParams as any).localId)
                return { message: 'Local não selecionado' }
        })()

    return (
        <DigitacaoSubPages
            Toolbar={LocaisToolbar}
            columns={columns}
            dataDiario={diario}
            dataMensal={mensal}
            diarioError={errorDiario}
            mensalError={errorMensal}
            isErrorDiario={!!errorDiario}
            isErrorMensal={!!errorMensal}
            isLoadingDiario={isLoadingDiario}
            isLoadingMensal={isLoadingMensal}
        />
    )
}
